import { useState } from "react";

const useMemberCard = (initialProps = {}) => {
  const [stateMemberCard, setState] = useState({
    isHovered: false,
  });

  const setMemberCard = (field, value) => {
    if (typeof field === "object") {
      setState((prevState) => ({ ...prevState, ...field }));
    } else {
      setState((prevState) => ({ ...prevState, [field]: value }));
    }
  };

  const toggleMemberCardField = (field) => {
    setState((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return {
    stateMemberCard,
    setMemberCard,
    toggleMemberCardField,
  };
};

export default useMemberCard;
